/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSPlusIcon16Solid = forwardRef('MediaAudioVolumeSPlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.51 1.694 3.704 5H1.5A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h2.204l3.806 3.306a.9.9 0 0 0 1.49-.68V2.374a.9.9 0 0 0-1.49-.68Z" }),
        React.createElement("path", { d: "M12 5.7a.7.7 0 0 1 .7-.7h.6a.7.7 0 0 1 .7.7V7h1.3a.7.7 0 0 1 .7.7v.6a.7.7 0 0 1-.7.7H14v1.3a.7.7 0 0 1-.7.7h-.6a.7.7 0 0 1-.7-.7V9h-1.3a.7.7 0 0 1-.7-.7v-.6a.7.7 0 0 1 .7-.7H12V5.7Z" })));
});
